import { CertificateSettingsInput } from '@/types/schema';

export const getDefaultCertificateSettings = ({
  disableLinkedInSharing,
  disableSocialSharing,
}: {
  disableLinkedInSharing: boolean;
  disableSocialSharing: boolean;
}): CertificateSettingsInput => ({
  certificateTemplateId: '',
  allowDownload: true,
  allowSocialSharing: !disableSocialSharing,
  allowLinkedinProfile: !disableLinkedInSharing,
});
